// Analytics Service - Orchestrates all tracking platforms
import * as Google from './Google.service';
import * as Facebook from './Facebook.service';

const isEnabled = () => window.__litium?.bft?.analyticsEnabled !== false;

const hasConsent = (category) => {
  try {
    const cookie = document.cookie
      .split('; ')
      .find((c) => c.startsWith('CookieScriptConsent='));
    if (!cookie) return false;

    const data = JSON.parse(decodeURIComponent(cookie.split('=')[1]));
    
    // Quick check for global actions
    if (data.action === 'reject') return false;
    if (data.action === 'accept') return true;

    // Check specific category consent (e.g. detailed settings)
    const cookieScriptCategory = data.googleconsentmap?.[category];
    if (cookieScriptCategory && data.categories) {
        const acceptedCategories = typeof data.categories === 'string' 
            ? JSON.parse(data.categories) 
            : data.categories;
        return acceptedCategories.includes(cookieScriptCategory);
    }

    return false;
  } catch (error) {
    console.error('[BFT Analytics] Consent check failed:', error);
    return false;
  }
};

const track = (eventName, data, googleFn, facebookFn) => {
  
  let trackingEnabled = isEnabled();

  // console.log(`[BFT Analytics], enabled: ${trackingEnabled}, event: ${eventName}:`, data);

  if (!trackingEnabled) 
    return;

  if (hasConsent('analytics_storage')) {
    googleFn(data);
  }
  if (hasConsent('ad_storage')) {
    // Facebook tracking temporarily disabled 
    // facebookFn(data);
  }
};

export const trackSearch = (searchTerm) =>
  track('Search', searchTerm, Google.trackSearch, Facebook.trackSearch);
export const trackViewItem = (product) =>
  track('View Item', product, Google.trackViewItem, Facebook.trackViewItem);
export const trackAddToCart = (item) =>
  track('Add to Cart', item, Google.trackAddToCart, Facebook.trackAddToCart);
export const trackBeginCheckout = (cart) => {
  if (!cart?.orderRows?.length) return;
  track(
    'Begin Checkout',
    {
      items: cart.orderRows.map((row) => ({
        item_id: row.articleNumber,
        item_name: row.name,
        price: row.quantity > 0 ? (row.totalPriceIncludingVat ?? 0) / row.quantity : 0,
        quantity: row.quantity,
      })),
      value: cart.grandTotalDecimal,
      currency: cart.currencyCode,
    },
    Google.trackBeginCheckout,
    Facebook.trackBeginCheckout
  );
};
export const trackPurchase = (purchase) =>
  track('Purchase', purchase, Google.trackPurchase, Facebook.trackPurchase);
